import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { EMPTY_OBJECT } from '../../constants';
import { themeColors, imageColors } from '../../lib/Color';
import Link from '../Link';
import SceneCard from '../SceneCard';

const CARD_TARGET_WIDTH = 450;

class SceneCardLayout extends React.PureComponent {
  static propTypes = {
    responsive: PropTypes.number,
    scenes: PropTypes.arrayOf(
      PropTypes.shape({
        allClips: PropTypes.array.isRequired,
        matchingClips: PropTypes.array,
      }),
    ),
    onHoverToggle: PropTypes.func,
  };
  static defaultProps = {
    isFiltered: false,
  };

  render() {
    const { responsive, scenes, onHoverToggle, ...otherProps } = this.props;

    const columns = Math.min(
      Math.max(Math.floor(responsive / CARD_TARGET_WIDTH), 1),
      4,
    );
    const bias = 100 / columns;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          margin: '0 -1rem',
        }}
      >
        {scenes.map((scene, index) => {
          const anyClip = get(scene.allClips, 0, EMPTY_OBJECT);

          let colorsTheme = EMPTY_OBJECT;
          let colorsImage = EMPTY_OBJECT;
          if (anyClip.scene_colors) {
            colorsTheme = themeColors(anyClip.scene_colors);
            colorsImage = imageColors(anyClip.scene_colors);
          }

          return (
            <div
              key={`${anyClip.scene_id}_${index}`}
              style={{
                padding: '1rem',
                flex: `0 1 ${bias}%`,
              }}
            >
              <Link to={`/browse/scene/${anyClip.scene_slug}`}>
                <SceneCard
                  title={anyClip.scene_name}
                  typeName={'Scene'}
                  backgroundColor={colorsImage.dark}
                  lqip={anyClip.scene_lqip}
                  images={[anyClip.scene_thumbnail]}
                  highlightColor={colorsTheme.highlight}
                  allClips={scene.allClips}
                  matchingClips={scene.matchingClips}
                  onHoverToggle={onHoverToggle}
                  onHoverData={anyClip.scene_id}
                />
              </Link>
            </div>
          );
        })}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    responsive: state.runtime.responsive,
  };
}

export default connect(mapStateToProps)(SceneCardLayout);



// WEBPACK FOOTER //
// ./src/components/SceneCardLayout/SceneCardLayout.js